import {COMMON_BUILDING_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {FORTRESS_MAX_DAMAGE} from "../../../configs/specialBuildings";
import {D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE} from "../../../configs/war";

/**
 * Вычисляет суммарный урон строения по hexKey
 * (!НО НЕ ДЛЯ ЯЧЕЕК С КРЕПОСТЯМИ!)
 * @param {string} hexKey - ключ ячейки
 * @param {Object} specialBuildings - специальные строения
 * @param {Object} buildingsDamage - уже применённые повреждения
 * @param {Array} pendingShootingActions - ожидающие действия стрельбы
 * @returns {number} суммарный урон
 */
export const getTotalBuildingNotFortressDamage = (hexKey, specialBuildings, buildingsDamage, pendingShootingActions) => {
  const applied = buildingsDamage?.[hexKey] || 0;

  const pending = (pendingShootingActions || []).filter(
    action => action.targetHexKey === hexKey && action.damage >= D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE
  ).length;
  return applied + pending;
};

/**
 * Возвращает порог разрушения для строения
 * (!НО НЕ ДЛЯ ЯЧЕЕК С КРЕПОСТЯМИ!)
 * @param {string} hexKey - ключ ячейки
 * @param {Object} specialBuildings - специальные строения
 * @returns {number}
 */
const getHexNotFortressToRoadDestructionThreshold = (hexKey, specialBuildings) => {
  if (specialBuildings?.[hexKey]) {
    return 4; // Остальные спецстроения при 4+
  }
  return 2; // Обычные строения при 2+
};

/**
 * Проверяет, разрушено ли строение
 * @param {string} hexKey - ключ ячейки
 * @param {Object} specialBuildings - специальные строения
 * @param {Object} buildingsDamage - уже применённые повреждения
 * @param {Array} pendingShootingActions - ожидающие действия стрельбы
 * @param {Object} hexes - состояние гексов (опционально, для проверки замены на дорогу)
 * @returns {boolean}
 */
export const isBuildingDestroyed = (hexKey, specialBuildings, buildingsDamage, pendingShootingActions, hexes) => {
  // Если на ячейке дорога — здание разрушено
  if (hexes && hexes[hexKey] === COMMON_BUILDING_TOKENS.ROAD) {
    return true;
  }

  // Для крепости нужна специальная логика: если крепость разрушена,
  // проверяем, разрушено ли базовое строение "следующими" экшенами
  if (specialBuildings?.[hexKey] === SPECIAL_BUILDING_TOKENS.FORTRESS) {
    const applied = buildingsDamage?.[hexKey] || 0;
    const relevantActions = (pendingShootingActions || []).filter(
      action => action.targetHexKey === hexKey
    );

    let fortressDamage = applied;
    let baseDamage = 0;
    let fortressDestroyed = false;

    for (const action of relevantActions) {
      if (!fortressDestroyed) {
        fortressDamage += action.damage;
        if (fortressDamage >= FORTRESS_MAX_DAMAGE) {
          fortressDestroyed = true;
        }
      } else {
        // Урон на базовое строение (4 к 1)
        if (action.damage >= 4) {
          baseDamage += 1;
        }
      }
    }

    if (!fortressDestroyed) {
      return false; // Крепость ещё цела
    }

    // Крепость разрушена — проверяем базовое строение
    return baseDamage >= 2;
  }

  const totalDamage = getTotalBuildingNotFortressDamage(hexKey, specialBuildings, buildingsDamage, pendingShootingActions);
  if (totalDamage <= 0) return false;

  const threshold = getHexNotFortressToRoadDestructionThreshold(hexKey, specialBuildings);
  return totalDamage >= threshold;
};
